import { useState } from 'react';

import { useConnectorsContextProvider } from 'features/connectors/context/connectors-provider';
import OrganisationUnit from 'features/organisation/domain/models/organisation-unit';

type LocationsModalHook = {
  showEditErrorPopup: boolean;
  handleOnSaveButtonClicked: () => void;
  handleOnClose: () => void;
  hidePopup: () => void;
};

type Props = {
  selectedLocations: OrganisationUnit[];
};

const useLocationsModal = ({ selectedLocations }: Props): LocationsModalHook => {
  const { connectorDetailsHook } = useConnectorsContextProvider();
  const { form, updateSelectedLocations, closeLocationPicker } = connectorDetailsHook;
  const [showEditErrorPopup, setShowEditErrorPopup] = useState<boolean>(false);

  const handleOnSaveButtonClicked = (): void => {
    const formOrganisationUnits = form.getValues('organisationUnits') ?? [];
    const hasUnlinkedOrganisationUnitsWithElectronicClientRecordLocations = formOrganisationUnits.some(
      (x) => !selectedLocations.some((y) => y.id === x.id) && x.hasAnyElectronicClientRecordLocationInChild,
    );

    if (hasUnlinkedOrganisationUnitsWithElectronicClientRecordLocations) {
      setShowEditErrorPopup(true);
      return;
    }

    updateSelectedLocations(selectedLocations);
    closeLocationPicker();
  };

  const handleOnClose = (): void => {
    closeLocationPicker();
  };

  const hidePopup = (): void => {
    setShowEditErrorPopup(false);
  };

  return {
    showEditErrorPopup,
    hidePopup,
    handleOnSaveButtonClicked,
    handleOnClose,
  };
};

export default useLocationsModal;
